module.exports = __webpack_public_path__ + "static/media/AB_illustration_greet.d8310371.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_illustration_greet.png
// module id = 592
// module chunks = 0